import { Shadows } from '@material-ui/core/styles/shadows'

export const noShadows = new Array(24).fill('none') as Shadows
